module.exports = __webpack_public_path__ + "img/france-cerebrovascular-disease-female.3fafce65.png";